import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Checkbox, Input, Radio, Space } from "antd";
import { Icon } from "assets/icons";
import { useState } from "react";
import { toLowerCaseNonAccentVietnamese } from "utils/helperFuncs";
import MenuLayout from "../MenuLayout";
import { t } from "i18next";

const SPACE_LAYOUT = {
  width: "100%",
  maxHeight: "200px",
  overflow: "auto",
  paddingBottom: "2px",
};

const FilterMenu = ({ onFilter, options, defaultValue, type = "checkbox", searchable }) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue);
  const [checkedList, setCheckedList] = useState(defaultValue || []);
  const [searchValue, setSearchValue] = useState("");

  const handleResetFilter = () => {
    setCheckedList([]);
    setSearchValue("");
    setSelectedValue(undefined);
  };

  const handleFilter = () => {
    switch (type) {
      case "checkbox": {
        onFilter && onFilter(checkedList);
        break;
      }
      case "radio": {
        onFilter && onFilter(selectedValue);
        break;
      }
      default:
        return;
    }
  };

  const handleChecked = (e) => {
    if (e?.target?.checked) {
      setCheckedList((prev) => [...prev, e?.target?.value]);
    } else {
      setCheckedList((prev) => prev?.filter((item) => item !== e?.target?.value));
    }
  };

  const handleSelected = (e) => {
    setSelectedValue(e.target.value);
  };

  const renderGroup = () => {
    switch (type) {
      case "checkbox":
        return (
          <Checkbox.Group value={checkedList}>
            <Space direction="vertical" style={SPACE_LAYOUT}>
              {options
                ?.filter((item) =>
                  toLowerCaseNonAccentVietnamese(item.label)?.includes(toLowerCaseNonAccentVietnamese(searchValue))
                )
                ?.map((item) => (
                  <Checkbox key={item.value} value={item.value} onChange={handleChecked}>
                    {item.label}
                  </Checkbox>
                ))}
            </Space>
          </Checkbox.Group>
        );
      case "radio":
        return (
          <Radio.Group value={selectedValue} onChange={handleSelected}>
            <Space direction="vertical" style={SPACE_LAYOUT}>
              {options
                ?.filter((item) => item?.label?.includes(searchValue))
                ?.map((item) => (
                  <Radio key={item.value} value={item.value}>
                    {item.label}
                  </Radio>
                ))}
            </Space>
          </Radio.Group>
        );
      default:
        return;
    }
  };

  return (
    <MenuLayout
      applyFilter={handleFilter}
      resetFilter={handleResetFilter}
      filterContent={
        <>
          {searchable && (
            <Input
              prefix={<FontAwesomeIcon icon={Icon.faSearch} />}
              placeholder={t("common.search")}
              allowClear={true}
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
              }}
            />
          )}
          {renderGroup()}
        </>
      }
    />
  );
};

export default FilterMenu;
